/* eslint-disable max-len */
import { FC, ReactElement } from 'react'

import { SvgIconProps } from '../Icon'

const IconNote: FC<SvgIconProps> = ({ className = '' }): ReactElement => (
    <svg className={`icon-component ${className}`} viewBox="0 0 14 14">
        <path d="M1.40625 1.40625V11.7188H8.4375V8.4375H11.7188V1.40625H1.40625ZM8.4375 13.125H1.40625H0V11.7188V1.40625V0H1.40625H11.7188H13.125V1.40625V8.4375V9.375L9.375 13.125H8.4375Z" />
    </svg>
)

export default IconNote
/* eslint-enable max-len */
